// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@7.1.4_@rspack+core@1.7.11_webpack@5.106.2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@7.1.4_@rspack+core@1.7.11_webpack@5.106.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-family: "Montserrat", -apple-system, BlinkMacSystemFont, "Segoe UI",
    "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans",
    "Helvetica Neue", sans-serif;
  font-weight: 400;

  background: #f5f5f5;
  /* background: #57c2e0;
  color: white; */

  overflow-x: hidden;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New",
    monospace;
}

*,
*:before,
*:after {
  box-sizing: border-box;
}

:root {
  --color-default-font: #161616;
  --color-primary: #73cea7;
}

.rc-steps {
  font-size: 0;
  width: 100%;
  line-height: 1.5;
  display: flex;
}
.rc-steps,
.rc-steps * {
  box-sizing: border-box;
}
.rc-steps-item {
  position: relative;
  display: inline-block;
  vertical-align: top;
  flex: 1;
  overflow: hidden;
}
.rc-steps-item-container[role="button"] {
  cursor: pointer;
  transition: opacity 0.3s;
}
.rc-steps-item-container[role="button"]:hover {
  opacity: 0.7;
}
.rc-steps-item:last-child {
  flex: none;
}
.rc-steps-item:last-child .rc-steps-item-tail,
.rc-steps-item:last-child .rc-steps-item-title:after {
  display: none;
}
.rc-steps-item-container {
  display: inline-block;
}
.rc-steps-item-icon,
.rc-steps-item-content {
  display: inline-block;
  vertical-align: top;
}
.rc-steps-item-icon {
  border: 1px solid #ccc;
  width: 26px;
  height: 26px;
  line-height: 26px;
  text-align: center;
  border-radius: 26px;
  font-size: 14px;
  margin-right: 8px;
  transition: background-color 0.3s, border-color 0.3s;
}
.rc-steps-item-icon > .rc-steps-icon {
  line-height: 1;
  top: -1px;
  color: #73cea7;
  position: relative;
}
.rc-steps-item-icon > .rc-steps-icon.rcicon {
  font-size: 12px;
  position: relative;
  top: -2px;
}
.rc-steps-item-tail {
  position: absolute;
  left: 0;
  width: 100%;
  top: 12px;
  padding: 0 10px;
}
.rc-steps-item-tail:after {
  content: "";
  display: inline-block;
  background: #e9e9e9;
  height: 1px;
  border-radius: 1px;
  width: 100%;
  transition: background 0.3s;
}
.rc-steps-item-content {
  margin-top: 3px;
}
.rc-steps-item-title {
  font-size: 14px;
  margin-bottom: 4px;
  color: #666;
  font-weight: bold;
  display: inline-block;
  padding-right: 10px;
  position: relative;
}
.rc-steps-item-title:after {
  content: "";
  height: 1px;
  width: 1000px;
  background: #e9e9e9;
  display: block;
  position: absolute;
  top: 0.55em;
  left: 100%;
}
.rc-steps-item-subtitle {
  font-size: 12px;
  display: inline-block;
  color: #999;
  margin-left: 8px;
}
.rc-steps-item-description {
  font-size: 12px;
  color: #999;
}
.rc-steps-item-wait .rc-steps-item-icon {
  border-color: #ccc;
  background-color: #fff;
}
.rc-steps-item-wait .rc-steps-item-icon > .rc-steps-icon {
  color: #ccc;
}
.rc-steps-item-wait .rc-steps-item-icon > .rc-steps-icon .rc-steps-icon-dot {
  background: #ccc;
}
.rc-steps-item-wait .rc-steps-item-title {
  color: rgba(0, 0, 0, 0.43);
}
.rc-steps-item-wait .rc-steps-item-title:after {
  background-color: #e9e9e9;
}
.rc-steps-item-wait .rc-steps-item-description {
  color: rgba(0, 0, 0, 0.43);
}
.rc-steps-item-wait .rc-steps-item-tail:after {
  background-color: #e9e9e9;
}
.rc-steps-item-process .rc-steps-item-icon {
  border-color: #73cea7;
  background-color: #fff;
}
.rc-steps-item-process .rc-steps-item-icon > .rc-steps-icon {
  color: #73cea7;
}
.rc-steps-item-process .rc-steps-item-icon > .rc-steps-icon .rc-steps-icon-dot {
  background: #73cea7;
}
.rc-steps-item-process .rc-steps-item-title {
  color: rgba(0, 0, 0, 0.65);
}
.rc-steps-item-process .rc-steps-item-title:after {
  background-color: #e9e9e9;
}
.rc-steps-item-process .rc-steps-item-description {
  color: rgba(0, 0, 0, 0.65);
}
.rc-steps-item-process .rc-steps-item-tail:after {
  background-color: #e9e9e9;
}
.rc-steps-item-process .rc-steps-item-icon {
  background: #73cea7;
}
.rc-steps-item-process .rc-steps-item-icon > .rc-steps-icon {
  color: #fff;
}
.rc-steps-item-finish .rc-steps-item-icon {
  border-color: #73cea7;
  background-color: #fff;
}
.rc-steps-item-finish .rc-steps-item-icon > .rc-steps-icon {
  color: #73cea7;
}
.rc-steps-item-finish .rc-steps-item-icon > .rc-steps-icon .rc-steps-icon-dot {
  background: #73cea7;
}
.rc-steps-item-finish .rc-steps-item-title {
  color: rgba(0, 0, 0, 0.43);
}
.rc-steps-item-finish .rc-steps-item-title:after {
  background-color: #73cea7;
}
.rc-steps-item-finish .rc-steps-item-description {
  color: rgba(0, 0, 0, 0.43);
}
.rc-steps-item-finish .rc-steps-item-tail:after {
  background-color: #73cea7;
}
.rc-steps-item-error .rc-steps-item-icon {
  border-color: #f50;
  background-color: #fff;
}
.rc-steps-item-error .rc-steps-item-icon > .rc-steps-icon {
  color: #f50;
}
.rc-steps-item-error .rc-steps-item-icon > .rc-steps-icon .rc-steps-icon-dot {
  background: #f50;
}
.rc-steps-item-error .rc-steps-item-title {
  color: #f50;
}
.rc-steps-item-error .rc-steps-item-title:after {
  background-color: #e9e9e9;
}
.rc-steps-item-error .rc-steps-item-description {
  color: #f50;
}
.rc-steps-item-error .rc-steps-item-tail:after {
  background-color: #e9e9e9;
}
.rc-steps-item.rc-steps-next-error .rc-steps-item-title:after {
  background: #f50;
}
.rc-steps-horizontal:not(.rc-steps-label-vertical) .rc-steps-item {
  margin-right: 10px;
}
.rc-steps-horizontal:not(.rc-steps-label-vertical) .rc-steps-item:last-child {
  margin-right: 0;
}
.rc-steps-horizontal:not(.rc-steps-label-vertical) .rc-steps-item-tail {
  display: none;
}
.rc-steps-horizontal:not(.rc-steps-label-vertical) .rc-steps-item-description {
  max-width: 100px;
}
.rc-steps-item-custom .rc-steps-item-icon {
  background: none;
  border: 0;
  width: auto;
  height: auto;
}
.rc-steps-item-custom .rc-steps-item-icon > .rc-steps-icon {
  font-size: 20px;
  top: 1px;
  width: 20px;
  height: 20px;
}
.rc-steps-item-custom.rc-steps-item-process
  .rc-steps-item-icon
  > .rc-steps-icon {
  color: #73cea7;
}
.rc-steps-small .rc-steps-item-icon {
  width: 18px;
  height: 18px;
  line-height: 18px;
  text-align: center;
  border-radius: 18px;
  font-size: 12px;
  margin-right: 10px;
}
.rc-steps-small .rc-steps-item-icon > .rc-steps-icon {
  font-size: 12px;
  font-size: 9px \\9;
  transform: scale(0.75);
  top: -1px;
}
.rc-steps-small .rc-steps-item-content {
  margin-top: 0;
}
.rc-steps-small .rc-steps-item-title {
  font-size: 12px;
  margin-bottom: 4px;
  color: #666;
  font-weight: bold;
}
.rc-steps-small .rc-steps-item-description {
  font-size: 12px;
  color: #999;
}
.rc-steps-small .rc-steps-item-tail {
  top: 8px;
  padding: 0 8px;
}
.rc-steps-small .rc-steps-item-tail:after {
  height: 1px;
  border-radius: 1px;
  width: 100%;
}
.rc-steps-small .rc-steps-item-custom .rc-steps-item-icon {
  width: inherit;
  height: inherit;
  line-height: inherit;
  border-radius: 0;
  border: 0;
  background: none;
}
.rc-steps-small .rc-steps-item-custom .rc-steps-item-icon > .rc-steps-icon {
  font-size: 20px;
  top: -2.5px;
  transform: none;
}
.rc-steps-vertical {
  display: block;
}
.rc-steps-vertical .rc-steps-item {
  display: block;
  overflow: visible;
}
.rc-steps-vertical .rc-steps-item-icon {
  float: left;
}
.rc-steps-vertical .rc-steps-item-icon-inner {
  margin-right: 16px;
}
.rc-steps-vertical .rc-steps-item-content {
  min-height: 48px;
  overflow: hidden;
  display: block;
}
.rc-steps-vertical .rc-steps-item-title {
  line-height: 26px;
}
.rc-steps-vertical .rc-steps-item-title:after {
  display: none;
}
.rc-steps-vertical .rc-steps-item-description {
  padding-bottom: 12px;
}
.rc-steps-vertical .rc-steps-item-tail {
  position: absolute;
  left: 13px;
  top: 0;
  height: 100%;
  width: 1px;
  padding: 30px 0 4px 0;
}
.rc-steps-vertical .rc-steps-item-tail:after {
  height: 100%;
  width: 1px;
}
.rc-steps-vertical.rc-steps-small .rc-steps-item-tail {
  position: absolute;
  left: 9px;
  top: 0;
  padding: 22px 0 4px 0;
}
.rc-steps-vertical.rc-steps-small .rc-steps-item-title {
  line-height: 18px;
}
.rc-steps-label-vertical .rc-steps-item {
  overflow: visible;
}
.rc-steps-label-vertical .rc-steps-item-tail {
  padding: 0px 24px;
  margin-left: 48px;
}
.rc-steps-label-vertical .rc-steps-item-content {
  display: block;
  text-align: center;
  margin-top: 8px;
  width: 100px;
}
.rc-steps-label-vertical .rc-steps-item-icon {
  display: inline-block;
  margin-left: 36px;
}
.rc-steps-label-vertical .rc-steps-item-title {
  padding-right: 0;
}
.rc-steps-label-vertical .rc-steps-item-title:after {
  display: none;
}
.rc-steps-label-vertical .rc-steps-item-description {
  text-align: left;
}
.rc-steps-dot .rc-steps-item-tail {
  width: 100%;
  top: 1px;
  margin: 0 0 0 50px;
  padding: 0;
}
.rc-steps-dot .rc-steps-item-tail:after {
  height: 3px;
}
.rc-steps-dot .rc-steps-item-icon {
  padding-right: 0;
  width: 5px;
  height: 5px;
  line-height: 5px;
  border: 0;
  margin-left: 48px;
}
.rc-steps-dot .rc-steps-item-icon .rc-steps-icon-dot {
  float: left;
  width: 100%;
  height: 100%;
  border-radius: 2.5px;
}
.rc-steps-dot .rc-steps-item-process .rc-steps-dot .rc-steps-item-icon {
  top: -1px;
  width: 7px;
  height: 7px;
  line-height: 7px;
}
.rc-steps-dot
  .rc-steps-item-process
  .rc-steps-dot
  .rc-steps-item-icon
  .rc-steps-icon-dot {
  border-radius: 3.5px;
}
.rc-steps-navigation {
  padding-top: 8px;
}
.rc-steps-navigation.rc-steps-horizontal .rc-steps-item-description {
  max-width: 140px;
}
.rc-steps-navigation .rc-steps-item {
  box-sizing: border-box;
  text-align: center;
  overflow: visible;
}
.rc-steps-navigation .rc-steps-item-container {
  text-align: left;
  padding-bottom: 8px;
  outline: none;
}
.rc-steps-navigation .rc-steps-item-title {
  max-width: 140px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.rc-steps-navigation .rc-steps-item-title:after {
  display: none;
}
.rc-steps-navigation .rc-steps-item:last-child {
  flex: 1;
}
.rc-steps-navigation .rc-steps-item:last-child:after {
  display: none;
}
.rc-steps-navigation .rc-steps-item:after {
  content: "";
  display: inline-block;
  width: 16px;
  height: 16px;
  border: 1px solid #ccc;
  border-bottom: none;
  border-left: none;
  transform: rotate(45deg);
  position: absolute;
  top: 50%;
  left: 100%;
  margin-top: -12px;
  margin-left: -8px;
}
.rc-steps-navigation .rc-steps-item-active .rc-steps-item-container {
  padding-bottom: 5px;
  border-bottom: 3px solid #73cea7;
}
`, "",{"version":3,"sources":["webpack://./app/js/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,mCAAmC;EACnC,kCAAkC;EAClC;;gCAE8B;EAC9B,gBAAgB;;EAEhB,mBAAmB;EACnB;iBACe;;EAEf,kBAAkB;AACpB;;AAEA;EACE;aACW;AACb;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;EAC7B,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,aAAa;AACf;AACA;;EAEE,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;EACnB,OAAO;EACP,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,wBAAwB;AAC1B;AACA;EACE,YAAY;AACd;AACA;EACE,UAAU;AACZ;AACA;;EAEE,aAAa;AACf;AACA;EACE,qBAAqB;AACvB;AACA;;EAEE,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,oDAAoD;AACtD;AACA;EACE,cAAc;EACd,SAAS;EACT,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,OAAO;EACP,WAAW;EACX,SAAS;EACT,eAAe;AACjB;AACA;EACE,WAAW;EACX,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,2BAA2B;AAC7B;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,UAAU;AACZ;AACA;EACE,eAAe;EACf,qBAAqB;EACrB,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,WAAW;AACb;AACA;EACE,gBAAgB;AAClB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;AACA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,WAAW;AACb;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;AACb;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,WAAW;AACb;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,SAAS;EACT,WAAW;EACX,YAAY;AACd;AACA;EACE,eAAe;EACf,QAAQ;EACR,WAAW;EACX,YAAY;AACd;AACA;;;EAGE,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,WAAW;AACb;AACA;EACE,QAAQ;EACR,cAAc;AAChB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,WAAW;EACX,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,WAAW;AACb;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;AACf;AACA;EACE,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,MAAM;EACN,YAAY;EACZ,UAAU;EACV,qBAAqB;AACvB;AACA;EACE,YAAY;EACZ,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,MAAM;EACN,qBAAqB;AACvB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,YAAY;AACd;AACA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,QAAQ;EACR,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,SAAS;EACT,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,oBAAoB;AACtB;AACA;EACE,SAAS;EACT,UAAU;EACV,WAAW;EACX,gBAAgB;AAClB;AACA;;;;;EAKE,oBAAoB;AACtB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,aAAa;AACf;AACA;EACE,OAAO;AACT;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,wBAAwB;EACxB,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,gCAAgC;AAClC","sourcesContent":["body {\n  margin: 0;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  font-family: \"Montserrat\", -apple-system, BlinkMacSystemFont, \"Segoe UI\",\n    \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Cantarell\", \"Fira Sans\", \"Droid Sans\",\n    \"Helvetica Neue\", sans-serif;\n  font-weight: 400;\n\n  background: #f5f5f5;\n  /* background: #57c2e0;\n  color: white; */\n\n  overflow-x: hidden;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, \"Courier New\",\n    monospace;\n}\n\n*,\n*:before,\n*:after {\n  box-sizing: border-box;\n}\n\n:root {\n  --color-default-font: #161616;\n  --color-primary: #73cea7;\n}\n\n.rc-steps {\n  font-size: 0;\n  width: 100%;\n  line-height: 1.5;\n  display: flex;\n}\n.rc-steps,\n.rc-steps * {\n  box-sizing: border-box;\n}\n.rc-steps-item {\n  position: relative;\n  display: inline-block;\n  vertical-align: top;\n  flex: 1;\n  overflow: hidden;\n}\n.rc-steps-item-container[role=\"button\"] {\n  cursor: pointer;\n  transition: opacity 0.3s;\n}\n.rc-steps-item-container[role=\"button\"]:hover {\n  opacity: 0.7;\n}\n.rc-steps-item:last-child {\n  flex: none;\n}\n.rc-steps-item:last-child .rc-steps-item-tail,\n.rc-steps-item:last-child .rc-steps-item-title:after {\n  display: none;\n}\n.rc-steps-item-container {\n  display: inline-block;\n}\n.rc-steps-item-icon,\n.rc-steps-item-content {\n  display: inline-block;\n  vertical-align: top;\n}\n.rc-steps-item-icon {\n  border: 1px solid #ccc;\n  width: 26px;\n  height: 26px;\n  line-height: 26px;\n  text-align: center;\n  border-radius: 26px;\n  font-size: 14px;\n  margin-right: 8px;\n  transition: background-color 0.3s, border-color 0.3s;\n}\n.rc-steps-item-icon > .rc-steps-icon {\n  line-height: 1;\n  top: -1px;\n  color: #73cea7;\n  position: relative;\n}\n.rc-steps-item-icon > .rc-steps-icon.rcicon {\n  font-size: 12px;\n  position: relative;\n  top: -2px;\n}\n.rc-steps-item-tail {\n  position: absolute;\n  left: 0;\n  width: 100%;\n  top: 12px;\n  padding: 0 10px;\n}\n.rc-steps-item-tail:after {\n  content: \"\";\n  display: inline-block;\n  background: #e9e9e9;\n  height: 1px;\n  border-radius: 1px;\n  width: 100%;\n  transition: background 0.3s;\n}\n.rc-steps-item-content {\n  margin-top: 3px;\n}\n.rc-steps-item-title {\n  font-size: 14px;\n  margin-bottom: 4px;\n  color: #666;\n  font-weight: bold;\n  display: inline-block;\n  padding-right: 10px;\n  position: relative;\n}\n.rc-steps-item-title:after {\n  content: \"\";\n  height: 1px;\n  width: 1000px;\n  background: #e9e9e9;\n  display: block;\n  position: absolute;\n  top: 0.55em;\n  left: 100%;\n}\n.rc-steps-item-subtitle {\n  font-size: 12px;\n  display: inline-block;\n  color: #999;\n  margin-left: 8px;\n}\n.rc-steps-item-description {\n  font-size: 12px;\n  color: #999;\n}\n.rc-steps-item-wait .rc-steps-item-icon {\n  border-color: #ccc;\n  background-color: #fff;\n}\n.rc-steps-item-wait .rc-steps-item-icon > .rc-steps-icon {\n  color: #ccc;\n}\n.rc-steps-item-wait .rc-steps-item-icon > .rc-steps-icon .rc-steps-icon-dot {\n  background: #ccc;\n}\n.rc-steps-item-wait .rc-steps-item-title {\n  color: rgba(0, 0, 0, 0.43);\n}\n.rc-steps-item-wait .rc-steps-item-title:after {\n  background-color: #e9e9e9;\n}\n.rc-steps-item-wait .rc-steps-item-description {\n  color: rgba(0, 0, 0, 0.43);\n}\n.rc-steps-item-wait .rc-steps-item-tail:after {\n  background-color: #e9e9e9;\n}\n.rc-steps-item-process .rc-steps-item-icon {\n  border-color: #73cea7;\n  background-color: #fff;\n}\n.rc-steps-item-process .rc-steps-item-icon > .rc-steps-icon {\n  color: #73cea7;\n}\n.rc-steps-item-process .rc-steps-item-icon > .rc-steps-icon .rc-steps-icon-dot {\n  background: #73cea7;\n}\n.rc-steps-item-process .rc-steps-item-title {\n  color: rgba(0, 0, 0, 0.65);\n}\n.rc-steps-item-process .rc-steps-item-title:after {\n  background-color: #e9e9e9;\n}\n.rc-steps-item-process .rc-steps-item-description {\n  color: rgba(0, 0, 0, 0.65);\n}\n.rc-steps-item-process .rc-steps-item-tail:after {\n  background-color: #e9e9e9;\n}\n.rc-steps-item-process .rc-steps-item-icon {\n  background: #73cea7;\n}\n.rc-steps-item-process .rc-steps-item-icon > .rc-steps-icon {\n  color: #fff;\n}\n.rc-steps-item-finish .rc-steps-item-icon {\n  border-color: #73cea7;\n  background-color: #fff;\n}\n.rc-steps-item-finish .rc-steps-item-icon > .rc-steps-icon {\n  color: #73cea7;\n}\n.rc-steps-item-finish .rc-steps-item-icon > .rc-steps-icon .rc-steps-icon-dot {\n  background: #73cea7;\n}\n.rc-steps-item-finish .rc-steps-item-title {\n  color: rgba(0, 0, 0, 0.43);\n}\n.rc-steps-item-finish .rc-steps-item-title:after {\n  background-color: #73cea7;\n}\n.rc-steps-item-finish .rc-steps-item-description {\n  color: rgba(0, 0, 0, 0.43);\n}\n.rc-steps-item-finish .rc-steps-item-tail:after {\n  background-color: #73cea7;\n}\n.rc-steps-item-error .rc-steps-item-icon {\n  border-color: #f50;\n  background-color: #fff;\n}\n.rc-steps-item-error .rc-steps-item-icon > .rc-steps-icon {\n  color: #f50;\n}\n.rc-steps-item-error .rc-steps-item-icon > .rc-steps-icon .rc-steps-icon-dot {\n  background: #f50;\n}\n.rc-steps-item-error .rc-steps-item-title {\n  color: #f50;\n}\n.rc-steps-item-error .rc-steps-item-title:after {\n  background-color: #e9e9e9;\n}\n.rc-steps-item-error .rc-steps-item-description {\n  color: #f50;\n}\n.rc-steps-item-error .rc-steps-item-tail:after {\n  background-color: #e9e9e9;\n}\n.rc-steps-item.rc-steps-next-error .rc-steps-item-title:after {\n  background: #f50;\n}\n.rc-steps-horizontal:not(.rc-steps-label-vertical) .rc-steps-item {\n  margin-right: 10px;\n}\n.rc-steps-horizontal:not(.rc-steps-label-vertical) .rc-steps-item:last-child {\n  margin-right: 0;\n}\n.rc-steps-horizontal:not(.rc-steps-label-vertical) .rc-steps-item-tail {\n  display: none;\n}\n.rc-steps-horizontal:not(.rc-steps-label-vertical) .rc-steps-item-description {\n  max-width: 100px;\n}\n.rc-steps-item-custom .rc-steps-item-icon {\n  background: none;\n  border: 0;\n  width: auto;\n  height: auto;\n}\n.rc-steps-item-custom .rc-steps-item-icon > .rc-steps-icon {\n  font-size: 20px;\n  top: 1px;\n  width: 20px;\n  height: 20px;\n}\n.rc-steps-item-custom.rc-steps-item-process\n  .rc-steps-item-icon\n  > .rc-steps-icon {\n  color: #73cea7;\n}\n.rc-steps-small .rc-steps-item-icon {\n  width: 18px;\n  height: 18px;\n  line-height: 18px;\n  text-align: center;\n  border-radius: 18px;\n  font-size: 12px;\n  margin-right: 10px;\n}\n.rc-steps-small .rc-steps-item-icon > .rc-steps-icon {\n  font-size: 12px;\n  font-size: 9px \\9;\n  transform: scale(0.75);\n  top: -1px;\n}\n.rc-steps-small .rc-steps-item-content {\n  margin-top: 0;\n}\n.rc-steps-small .rc-steps-item-title {\n  font-size: 12px;\n  margin-bottom: 4px;\n  color: #666;\n  font-weight: bold;\n}\n.rc-steps-small .rc-steps-item-description {\n  font-size: 12px;\n  color: #999;\n}\n.rc-steps-small .rc-steps-item-tail {\n  top: 8px;\n  padding: 0 8px;\n}\n.rc-steps-small .rc-steps-item-tail:after {\n  height: 1px;\n  border-radius: 1px;\n  width: 100%;\n}\n.rc-steps-small .rc-steps-item-custom .rc-steps-item-icon {\n  width: inherit;\n  height: inherit;\n  line-height: inherit;\n  border-radius: 0;\n  border: 0;\n  background: none;\n}\n.rc-steps-small .rc-steps-item-custom .rc-steps-item-icon > .rc-steps-icon {\n  font-size: 20px;\n  top: -2.5px;\n  transform: none;\n}\n.rc-steps-vertical {\n  display: block;\n}\n.rc-steps-vertical .rc-steps-item {\n  display: block;\n  overflow: visible;\n}\n.rc-steps-vertical .rc-steps-item-icon {\n  float: left;\n}\n.rc-steps-vertical .rc-steps-item-icon-inner {\n  margin-right: 16px;\n}\n.rc-steps-vertical .rc-steps-item-content {\n  min-height: 48px;\n  overflow: hidden;\n  display: block;\n}\n.rc-steps-vertical .rc-steps-item-title {\n  line-height: 26px;\n}\n.rc-steps-vertical .rc-steps-item-title:after {\n  display: none;\n}\n.rc-steps-vertical .rc-steps-item-description {\n  padding-bottom: 12px;\n}\n.rc-steps-vertical .rc-steps-item-tail {\n  position: absolute;\n  left: 13px;\n  top: 0;\n  height: 100%;\n  width: 1px;\n  padding: 30px 0 4px 0;\n}\n.rc-steps-vertical .rc-steps-item-tail:after {\n  height: 100%;\n  width: 1px;\n}\n.rc-steps-vertical.rc-steps-small .rc-steps-item-tail {\n  position: absolute;\n  left: 9px;\n  top: 0;\n  padding: 22px 0 4px 0;\n}\n.rc-steps-vertical.rc-steps-small .rc-steps-item-title {\n  line-height: 18px;\n}\n.rc-steps-label-vertical .rc-steps-item {\n  overflow: visible;\n}\n.rc-steps-label-vertical .rc-steps-item-tail {\n  padding: 0px 24px;\n  margin-left: 48px;\n}\n.rc-steps-label-vertical .rc-steps-item-content {\n  display: block;\n  text-align: center;\n  margin-top: 8px;\n  width: 100px;\n}\n.rc-steps-label-vertical .rc-steps-item-icon {\n  display: inline-block;\n  margin-left: 36px;\n}\n.rc-steps-label-vertical .rc-steps-item-title {\n  padding-right: 0;\n}\n.rc-steps-label-vertical .rc-steps-item-title:after {\n  display: none;\n}\n.rc-steps-label-vertical .rc-steps-item-description {\n  text-align: left;\n}\n.rc-steps-dot .rc-steps-item-tail {\n  width: 100%;\n  top: 1px;\n  margin: 0 0 0 50px;\n  padding: 0;\n}\n.rc-steps-dot .rc-steps-item-tail:after {\n  height: 3px;\n}\n.rc-steps-dot .rc-steps-item-icon {\n  padding-right: 0;\n  width: 5px;\n  height: 5px;\n  line-height: 5px;\n  border: 0;\n  margin-left: 48px;\n}\n.rc-steps-dot .rc-steps-item-icon .rc-steps-icon-dot {\n  float: left;\n  width: 100%;\n  height: 100%;\n  border-radius: 2.5px;\n}\n.rc-steps-dot .rc-steps-item-process .rc-steps-dot .rc-steps-item-icon {\n  top: -1px;\n  width: 7px;\n  height: 7px;\n  line-height: 7px;\n}\n.rc-steps-dot\n  .rc-steps-item-process\n  .rc-steps-dot\n  .rc-steps-item-icon\n  .rc-steps-icon-dot {\n  border-radius: 3.5px;\n}\n.rc-steps-navigation {\n  padding-top: 8px;\n}\n.rc-steps-navigation.rc-steps-horizontal .rc-steps-item-description {\n  max-width: 140px;\n}\n.rc-steps-navigation .rc-steps-item {\n  box-sizing: border-box;\n  text-align: center;\n  overflow: visible;\n}\n.rc-steps-navigation .rc-steps-item-container {\n  text-align: left;\n  padding-bottom: 8px;\n  outline: none;\n}\n.rc-steps-navigation .rc-steps-item-title {\n  max-width: 140px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.rc-steps-navigation .rc-steps-item-title:after {\n  display: none;\n}\n.rc-steps-navigation .rc-steps-item:last-child {\n  flex: 1;\n}\n.rc-steps-navigation .rc-steps-item:last-child:after {\n  display: none;\n}\n.rc-steps-navigation .rc-steps-item:after {\n  content: \"\";\n  display: inline-block;\n  width: 16px;\n  height: 16px;\n  border: 1px solid #ccc;\n  border-bottom: none;\n  border-left: none;\n  transform: rotate(45deg);\n  position: absolute;\n  top: 50%;\n  left: 100%;\n  margin-top: -12px;\n  margin-left: -8px;\n}\n.rc-steps-navigation .rc-steps-item-active .rc-steps-item-container {\n  padding-bottom: 5px;\n  border-bottom: 3px solid #73cea7;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
